'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/utils';
export function Container(t0) {
  const $ = _c(8);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[3] !== className) {
    t2 = cn(className);
    $[3] = className;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== props.children || $[6] !== t2) {
    t3 = <div className={t2}>{props.children}</div>;
    $[5] = props.children;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}